import React, { useState } from "react";

export default function MfgLoanForm() {
  const [agree, setAgree] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    purpose: "",
    manufacturerName: "",
    factorySize: "",
    location: "",
    machineryType: "",
    loanAmount: "",
    emiCount: "",
    annualRevenue: "",
    collateral: "",
    remarks: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!agree) {
      alert("⚠️ You must agree to the Terms & Conditions before submitting.");
      return;
    }
    // console.log("Manufacturing Loan Application Submitted:", formData);
    alert("✅ Loan Application submitted! Our Finance Partner will contact you.");
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-800 p-6">
      <form
        onSubmit={handleSubmit}
        className="bg-gray-700 shadow-lg rounded-2xl p-6 w-full max-w-lg border border-gray-500"
      >
        <h2 className="text-xl font-bold text-center text-yellow-200 mb-6">
          🏭 MfgLoan: Empowering Manufacturers with Easy Financing
        </h2>

        {/* Loan Purpose */}
        <label className="block mb-2 font-medium">Loan Purpose</label>
        <select
          name="purpose"
          value={formData.purpose}
          onChange={handleChange}
          className="h-10 p-2 mb-4 border rounded-lg"
        >
          <option value="">-- Select Purpose --</option>
          <option value="Machinery">Machinery Purchase</option>
          <option value="FactorySetup">Factory Setup / Expansion</option>
          <option value="RawMaterial">Raw Material Procurement</option>
          <option value="WorkingCapital">Working Capital</option>
          <option value="Storage">Storage / Warehouse Setup</option>
          <option value="Other">Other</option>
        </select>

        {/* Manufacturer Details */}
        <label className="block mb-2 font-medium">Manufacturer Name / Company</label>
        <input
          type="text"
          name="manufacturerName"
          value={formData.manufacturerName}
          onChange={handleChange}
          className="w-full p-2 mb-4 border rounded-lg"
        />

        <label className="block mb-2 font-medium">Factory / Facility Size (in sq.ft.)</label>
        <input
          type="number"
          name="factorySize"
          value={formData.factorySize}
          onChange={handleChange}
          className="w-24 p-2 mb-4 border rounded-lg"
        />

        <label className="block mb-2 font-medium">Location</label>
        <input
          type="text"
          name="location"
          value={formData.location}
          onChange={handleChange}
          className="w-full p-2 mb-4 border rounded-lg"
        />

        <label className="block mb-2 font-medium">Machinery / Equipment Type</label>
        <input
          type="text"
          name="machineryType"
          value={formData.machineryType}
          onChange={handleChange}
          className="w-full p-2 mb-4 border rounded-lg"
        />

        {/* Financial Details */}
        <label className="block mb-2 font-medium">Loan Amount (₹)</label>
        <input
          type="number"
          name="loanAmount"
          value={formData.loanAmount}
          onChange={handleChange}
          className="w-full p-2 mb-4 border rounded-lg"
        />

        <label className="block mb-2 font-medium">Repayment Period</label>
        <select
          name="emiCount"
          value={formData.emiCount}
          onChange={handleChange}
          className="h-10 w-full p-2 mb-4 border rounded-lg"
        >
          <option value="">-- Select Loan Duration --</option>
          <option value="3">3 months</option>
          <option value="6">6 months</option>
          <option value="9">9 months</option>
          <option value="12">12 months</option>
          <option value="24">24 months</option>
        </select>

        <label className="block mb-2 font-medium">Annual Revenue (₹)</label>
        <input
          type="number"
          name="annualRevenue"
          value={formData.annualRevenue}
          onChange={handleChange}
          className="w-full p-2 mb-4 border rounded-lg"
        />

        <label className="block mb-2 font-medium">Collateral (if any)</label>
        <input
          type="text"
          name="collateral"
          value={formData.collateral}
          onChange={handleChange}
          className="w-full p-2 mb-4 border rounded-lg"
        />

        {/* Remarks */}
        <label className="block mb-2 font-medium">Remarks</label>
        <textarea
          name="remarks"
          value={formData.remarks}
          onChange={handleChange}
          style={{ height: "250px", width: "100%" }}
          className="w-full bg-gray-600 text-white p-2 mb-4 border rounded-lg text-sm"
        />

        {/* Terms & Conditions */}
        <div className="flex items-center mb-4">
          <input
            type="checkbox"
            checked={agree}
            onChange={(e) => setAgree(e.target.checked)}
            className="mr-2"
          />
          <button type="button" onClick={() => setShowModal(true)}>
            I agree to the Terms & Conditions
          </button>
        </div>

        {/* Submit */}
        <button type="submit" className="w-full bg-yellow-500 hover:bg-yellow-600 text-black py-2 rounded-lg">
          Submit Application
        </button>
      </form>

      {/* Terms Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-gray-700 rounded-2xl shadow-lg w-11/12 max-w-2xl p-6 overflow-y-auto max-h-[80vh]">
            <h2 className="text-xl font-bold mb-4 text-center text-yellow-200">
              🏭 MfgLoan Terms & Conditions
            </h2>
            <div className="text-sm text-white space-y-3">
              <p>1. Loans are disbursed by authorized NBFCs/Banks under SyntraMfg platform.</p>
              <p>2. Applicants must provide valid KYC and company/factory ownership documents.</p>
              <p>3. Timely repayments are mandatory; defaults may affect credit ratings.</p>
              <p>4. Loan amounts may be directly disbursed to vendors or equipment suppliers.</p>
              <p>5. SyntraMfg is not responsible for delays caused by financial partners.</p>
              <p>6. All submitted data is confidential and shared only with authorized lenders.</p>
              <p>7. All disputes fall under Indian jurisdiction (Mumbai courts).</p>
            </div>
            <div className="mt-6 flex justify-center">
              <button
                onClick={() => setShowModal(false)}
                className="bg-yellow-500 hover:bg-yellow-600 text-black px-4 py-2 rounded-lg"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
